import type { AxiosRequestConfig } from "axios";
import type { ApiRequest } from "./AuthenticatedRequest";
/** Common entity URL construction; response shapes and pagination belong to each API contract. */
export function createEntityApi(request: ApiRequest, trailingSlash = false) {
  const path = (entity: string, id?: number) => {
    if (!/^[a-zA-Z][a-zA-Z0-9_-]*$/.test(entity))
      throw new Error("Ungültiger Entity-Typ.");
    return `/entity/${entity}${id === undefined ? (trailingSlash ? "/" : "") : `/${id}`}`;
  };
  return {
    list: <T>(
      entity: string,
      config: AxiosRequestConfig = {},
      authenticated = true,
    ) =>
      request<T>(
        { ...config, url: path(entity), method: "GET" },
        authenticated,
      ),
    read: <T>(
      entity: string,
      id: number,
      config: AxiosRequestConfig = {},
      authenticated = true,
    ) =>
      request<T>(
        { ...config, url: path(entity, id), method: "GET" },
        authenticated,
      ),
    create: <T>(
      entity: string,
      data: unknown,
      config: AxiosRequestConfig = {},
      authenticated = true,
    ) =>
      request<T>(
        { ...config, url: path(entity), method: "POST", data },
        authenticated,
      ),
    update: <T>(
      entity: string,
      id: number,
      data: unknown,
      config: AxiosRequestConfig = {},
    ) => request<T>({ ...config, url: path(entity, id), method: "PUT", data }),
    remove: <T>(entity: string, id: number, config: AxiosRequestConfig = {}) =>
      request<T>({ ...config, url: path(entity, id), method: "DELETE" }),
  };
}
